enum ApplicationActions {
  WINDOW_RESIZED = '[application] Window resized'
}
export default ApplicationActions
